










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { WidgetThemesDictionary } from '@/models/Widget/themes';
import { IProvider } from '@/models/provider';

@Component({
  components: {
    Typography,
    Picture,
    FilledButton
  }
})
export default class CouponPreview extends Vue {
  @Prop({ default: '0' }) value?: string;
  @Prop({ default: '' }) initiative?: 'referral' | 'free-coins' | '';
  @Prop({ default: 'percentage' }) discountType?: 'percentage' | 'money';
  @Prop({ default: 'XXXXXXXXX' }) code?: string;

  get title() {
    if (this.discountType === 'percentage') {
      return `${this.value || 0}% OFF`;
    }

    return `${this.currencySymbol}${this.value || 0} OFF`;
  }

  get currentProvider(): IProvider | undefined {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get imageGradient() {
    if (this.currentProvider) {
      return WidgetThemesDictionary[this.currentProvider.settings.color]
        .backgroundGradient2Hover;
    }

    return 'linear-gradient(107.86deg, #4F3DFE -30.28%, #971FFD 114.75%)';
  }

  get countryData() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get currencySymbol() {
    return this.countryData.currencySymbol;
  }

  get currencyName() {
    return this.countryData.currencyShorthand || this.countryData.currency;
  }

  get tag() {
    if (this.initiative === 'referral') {
      return 'REFERRAL';
    }

    if (this.initiative === 'free-coins') {
      return 'FREE COINS';
    }

    return 'CONVERTED COINS';
  }
}
